import * as React from 'react';
import { CSSTransition } from 'react-transition-group';
import { classNames } from 'uitk-react-utils';
import styles from './uitk-sheet.css';
var getClassNameList = classNames.bind(styles);
var UitkSheetTransition = function (props) {
  var children = props.children,
    closeCallback = props.closeCallback,
    _a = props.isVisible,
    isVisible = _a === void 0 ? false : _a,
    openCallback = props.openCallback;
  var baseClassName = 'uitk-sheet';
  var enterTimeout;
  var exitTimeout;
  // Currently, sheet animation behavior is still being developed by design; as a result, many animation timings are hardcoded.
  // These values come from their respective sheet CSS files until their behavior is fully aligned.
  // See PR #6488 for more details.
  var sheetType = children.props.type;
  switch (sheetType) {
    case 'popover':
      enterTimeout = 180;
      exitTimeout = 60;
      break;
    case 'side':
      enterTimeout = 200;
      exitTimeout = 120;
      break;
    case 'bottom':
      enterTimeout = 275;
      exitTimeout = 275;
      break;
    default:
      // 275ms is the max transition time across sheets for entering and exiting.
      enterTimeout = 275;
      exitTimeout = 275;
  }
  return React.createElement(CSSTransition, {
    classNames: {
      enter: getClassNameList("".concat(baseClassName, "-enter")),
      enterActive: getClassNameList("".concat(baseClassName, "-enter-active")),
      exit: getClassNameList("".concat(baseClassName, "-exit")),
      exitActive: getClassNameList("".concat(baseClassName, "-exit-active"))
    },
    in: isVisible,
    unmountOnExit: true,
    timeout: {
      enter: enterTimeout,
      exit: exitTimeout
    },
    onEntered: openCallback,
    onExited: closeCallback
  }, children);
};
UitkSheetTransition.displayName = 'UitkSheetTransition';
export { UitkSheetTransition };